import React, { createContext } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { arrangeSingleInvoice } from '../utils/ListingHelpers'
import { NamedRoutes } from '../routes'
import ListingServices from '../Services/Consumers/ListingServices'
import { useKeycloak } from '@react-keycloak/web'
import CookiesStorageService from '../Services/CookiesStorageService'
import { InvoicesListingParamsPayload } from '../Services/Payloads/InvoicePayload'

const InvoiceViewContext = createContext({})

const InvoiceViewProvider = ({ id, locale, children, isMs }) => {
  const intl = useIntl()
  let history = useHistory()
  const { keycloak } = useKeycloak()

  const [invoiceData, setInvoiceData] = React.useState({})
  const [isUnauthorized, setIsUnauthorized] = React.useState(false)
  const [invoiceDataLoading, setInvoiceDataLoading] = React.useState(false)
  const [isUserSubmitter, setIsUserSubmitter] = React.useState(false)


  React.useEffect(() => {
      if (!!id) {
        if (!!isMs) getMsInvoiceData()
        else getInvoiceData()
      } else {
        history.push({
          pathname: NamedRoutes.invoices
        })
      }

    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])


  const getInvoiceData = () => {
    // let data = {
    //   'submissionUUID': 'EHR49PWA76RW1MXYADZ28M5G10',
    //   'dateTimeRecevied': '2022-06-15T17:55:37.0154048Z',
    //   'validationResults': {
    //     'status': 'Valid',
    //     'validationSteps': [
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-03. ITIDA Signature',
    //         'stepId': '4'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-04. NationalID Validator',
    //         'stepId': '6'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-05. TaxpayerProfile Validator',
    //         'stepId': '11'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-06. Simple Validator',
    //         'stepId': '14'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-07. Code Field Validator',
    //         'stepId': '15'
    //       }
    //     ]
    //   },
    //   'transformationStatus': 'original',
    //   'statusId': 2,
    //   'status': 'Valid',
    //   'documentStatusReason': '',
    //   'cancelRequestDate': null,
    //   'rejectRequestDate': null,
    //   'cancelRequestDelayedDate': null,
    //   'rejectRequestDelayedDate': null,
    //   'declineCancelRequestDate': null,
    //   'declineRejectRequestDate': null,
    //   'canbeCancelledUntil': '2022-06-18T17:55:25.7376355Z',
    //   'canbeRejectedUntil': '2022-06-16T05:55:25.7376355Z',
    //   'submissionChannel': 1,
    //   'uuid': 'G28N4AK18ZAPBM83ADZ28M5G10',
    //   'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/G28N4AK18ZAPBM83ADZ28M5G10/share/8RVWE40CHKGDK6HHADZ28M5G10ObQ0AG1655315725',
    //   'purchaseOrderDescription': 'purchase Order description',
    //   'totalItemsDiscountAmount': 0,
    //   'delivery': {
    //     'approach': 'SomeValue',
    //     'packaging': 'SomeValue',
    //     'dateValidity': '2022-06-11T09:30:10Z',
    //     'exportPort': 'SomeValue',
    //     'countryOfOrigin': '',
    //     'grossWeight': 10.5,
    //     'netWeight': 20.5,
    //     'terms': 'SomeValue'
    //   },
    //   'payment': {
    //     'bankName': 'SomeValue',
    //     'bankAddress': 'SomeValue',
    //     'bankAccountNo': 'SomeValue',
    //     'bankAccountIBAN': '',
    //     'swiftCode': '',
    //     'terms': ''
    //   },
    //   'totalAmount': 500,
    //   'taxTotals': [
    //     {
    //       'taxType': 'T1',
    //       'amount': 0
    //     }
    //   ],
    //   'netAmount': 500,
    //   'totalDiscount': 0,
    //   'totalSales': 500,
    //   'invoiceLines': [
    //     {
    //       'itemPrimaryName': 'white chees',
    //       'itemPrimaryDescription': 'white chees',
    //       'itemSecondaryName': 'جبنه بيضه',
    //       'itemSecondaryDescription': 'جبنه بيضه',
    //       'unitTypePrimaryName': 'each (ST) ( ST )',
    //       'unitTypePrimaryDescription': '',
    //       'unitTypeSecondaryName': '',
    //       'unitTypeSecondaryDescription': '',
    //       'salesTotalForeign': 500,
    //       'netTotalForeign': 500,
    //       'totalForeign': 500,
    //       'totalTaxableFeesForeign': 0,
    //       'itemsDiscountForeign': 0,
    //       'valueDifferenceForeign': 0,
    //       'discountForeign': {
    //         'amountForeign': 0,
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'lineTaxableItems': [
    //         {
    //           'amountForeign': 0,
    //           'taxType': 'T1',
    //           'amount': 0,
    //           'subType': 'V001',
    //           'rate': 0
    //         }
    //       ],
    //       'description': 'white chees',
    //       'itemType': 'EGS',
    //       'itemCode': 'EG-100000053-10015',
    //       'unitType': 'EA',
    //       'quantity': 1,
    //       'unitValue': {
    //         'currencySold': 'EGP',
    //         'amountSold': 0,
    //         'amountEGP': 500,
    //         'currencyExchangeRate': 0
    //       },
    //       'factoryUnitValue': null,
    //       'salesTotal': 500,
    //       'discount': {
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'taxableItems': null,
    //       'internalCode': 'IC0',
    //       'itemsDiscount': 0,
    //       'netTotal': 500,
    //       'totalTaxableFees': 0,
    //       'valueDifference': 0,
    //       'total': 500
    //     }
    //   ],
    //   'references': null,
    //   'salesOrderDescription': 'Sales Order description',
    //   'salesOrderReference': '1231',
    //   'proformaInvoiceNumber': 'SomeValue',
    //   'signatures': [
    //     {
    //       'signatureType': 'I',
    //       'value': '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',
    //       'signedBy': 'اركديف  منطقه حره'
    //     }
    //   ],
    //   'purchaseOrderReference': 'P-233-A6375',
    //   'internalID': '1000009925032',
    //   'taxpayerActivityCode': '8411',
    //   'dateTimeIssued': '2022-06-11T00:00:45Z',
    //   'documentTypeVersion': '1.0',
    //   'documentType': 'I',
    //   'documentTypeNamePrimaryLang': 'Invoice',
    //   'documentTypeNameSecondaryLang': 'فاتورة',
    //   'receiver': {
    //     'address': {
    //       'buildingNumber': 'Bldg. 0',
    //       'room': '123',
    //       'floor': '1',
    //       'street': '580 Clementina Key',
    //       'landmark': '7660 Melody Trail',
    //       'additionalInformation': 'beside Townhall',
    //       'governate': 'New Yourk',
    //       'regionCity': 'New Yourk',
    //       'postalCode': '10014',
    //       'country': 'US',
    //       'branchID': null
    //     },
    //     'type': 2,
    //     'id': '10201020102',
    //     'name': 'Reciver Man'
    //   },
    //   'issuer': {
    //     'address': {
    //       'buildingNumber': 'Bldg. 0',
    //       'room': '123',
    //       'floor': '1',
    //       'street': '580 Clementina Key',
    //       'landmark': '7660 Melody Trail',
    //       'additionalInformation': 'beside Townhall',
    //       'governate': 'Cairo',
    //       'regionCity': 'Nasr City',
    //       'postalCode': '68030',
    //       'country': 'EG',
    //       'branchID': '0'
    //     },
    //     'type': 0,
    //     'id': '628787103',
    //     'name': 'Mo Ali'
    //   },
    //   'extraDiscountAmount': 0,
    //   'maxPercision': 2,
    //   'currenciesSold': 'EGP',
    //   'currencySegments': [
    //     {
    //       'currency': 'EGP',
    //       'currencyExchangeRate': 0,
    //       'totalItemsDiscountAmount': 0,
    //       'totalAmount': 500,
    //       'taxTotals': [
    //         {
    //           'taxType': 'T1',
    //           'amount': 0
    //         }
    //       ],
    //       'netAmount': 500,
    //       'totalDiscount': 0,
    //       'totalSales': 500,
    //       'extraDiscountAmount': 0,
    //       'totalTaxableFees': 0
    //     }
    //   ]
    // }
    // let data = {
    //   'submissionUUID': 'QZ9AS3P3EBXTAP86JKVV0J5G10',
    //   'dateTimeRecevied': '2022-06-14T21:10:55.5979469Z',
    //   'validationResults': {
    //     'status': 'Invalid',
    //     'validationSteps': [
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-03. ITIDA Signature',
    //         'stepId': '4'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-04. NationalID Validator',
    //         'stepId': '6'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-05. TaxpayerProfile Validator',
    //         'stepId': '11'
    //       },
    //       {
    //         'status': 'Invalid',
    //         'error': {
    //           'propertyName': null,
    //           'propertyPath': null,
    //           'errorCode': 'Err06',
    //           'error': 'Invalid Simple Validator',
    //           'errorAr': 'بيانات الفاتوره غير صالحة',
    //           'innerError': [
    //             {
    //               'propertyName': 'TotalSalesAmount',
    //               'propertyPath': 'document.TotalSales',
    //               'errorCode': 'SF344',
    //               'error': 'TotalSalesAmount must be equal the sum of all Sales Total elements of Invoice lines',
    //               'errorAr': 'يجب أن يكون  قيمة اجمالى المبيعات مساويًا لمجموع كافة عناصر إجمالي المبيعات لبنود الفاتورة',
    //               'innerError': null
    //             },
    //             {
    //               'propertyName': 'NetAmount',
    //               'propertyPath': 'document.NetAmount',
    //               'errorCode': 'SF346',
    //               'error': 'NetAmount must be estimated correctly',
    //               'errorAr': 'يجب حساب صافى القيمة  بشكل صحيح',
    //               'innerError': null
    //             },
    //             {
    //               'propertyName': 'TotalAmount',
    //               'propertyPath': 'document.TotalAmount',
    //               'errorCode': 'SF350',
    //               'error': 'TotalAmount must be estimated correctly',
    //               'errorAr': 'يجب تقدير إجمالي المبلغ بشكل صحيح',
    //               'innerError': null
    //             }
    //           ]
    //         },
    //         'stepName': 'Step-06. Simple Validator',
    //         'stepId': '14'
    //       },
    //       {
    //         'status': 'Valid',
    //         'error': null,
    //         'stepName': 'Step-07. Code Field Validator',
    //         'stepId': '15'
    //       }
    //     ]
    //   },
    //   'transformationStatus': 'original',
    //   'statusId': 3,
    //   'status': 'Invalid',
    //   'documentStatusReason': '',
    //   'cancelRequestDate': null,
    //   'rejectRequestDate': null,
    //   'cancelRequestDelayedDate': null,
    //   'rejectRequestDelayedDate': null,
    //   'declineCancelRequestDate': null,
    //   'declineRejectRequestDate': null,
    //   'canbeCancelledUntil': '2022-06-17T21:10:43.5700143Z',
    //   'canbeRejectedUntil': '2022-06-15T09:10:43.5700143Z',
    //   'submissionChannel': 1,
    //   'uuid': 'DQJQ8RTHYE3Y6FRYJKVV0J5G10',
    //   'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/DQJQ8RTHYE3Y6FRYJKVV0J5G10/share/4S2KAJK8PQ3QA8AHKKVV0J5G10CzJLHo1655241043',
    //   'purchaseOrderDescription': 'purchase Order description',
    //   'totalItemsDiscountAmount': 0,
    //   'delivery': {
    //     'approach': 'SomeValue',
    //     'packaging': 'SomeValue',
    //     'dateValidity': '2022-06-11T09:30:10Z',
    //     'exportPort': 'SomeValue',
    //     'countryOfOrigin': '',
    //     'grossWeight': 10.5,
    //     'netWeight': 20.5,
    //     'terms': 'SomeValue'
    //   },
    //   'payment': {
    //     'bankName': 'SomeValue',
    //     'bankAddress': 'SomeValue',
    //     'bankAccountNo': 'SomeValue',
    //     'bankAccountIBAN': '',
    //     'swiftCode': '',
    //     'terms': ''
    //   },
    //   'totalAmount': 500,
    //   'taxTotals': [
    //     {
    //       'taxType': 'T1',
    //       'amount': 0
    //     }
    //   ],
    //   'netAmount': 500,
    //   'totalDiscount': 0,
    //   'totalSales': 500,
    //   'invoiceLines': [
    //     {
    //       'itemPrimaryName': 'white chees',
    //       'itemPrimaryDescription': 'white chees',
    //       'itemSecondaryName': 'جبنه بيضه',
    //       'itemSecondaryDescription': 'جبنه بيضه',
    //       'unitTypePrimaryName': 'each (ST) ( ST )',
    //       'unitTypePrimaryDescription': '',
    //       'unitTypeSecondaryName': '',
    //       'unitTypeSecondaryDescription': '',
    //       'salesTotalForeign': 500,
    //       'netTotalForeign': 500,
    //       'totalForeign': 500,
    //       'totalTaxableFeesForeign': 0,
    //       'itemsDiscountForeign': 0,
    //       'valueDifferenceForeign': 0,
    //       'discountForeign': {
    //         'amountForeign': 0,
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'lineTaxableItems': [
    //         {
    //           'amountForeign': 0,
    //           'taxType': 'T1',
    //           'amount': 0,
    //           'subType': 'V001',
    //           'rate': 0
    //         }
    //       ],
    //       'description': 'Computer1',
    //       'itemType': 'EGS',
    //       'itemCode': 'EG-100000053-10015',
    //       'unitType': 'EA',
    //       'quantity': 1,
    //       'unitValue': {
    //         'currencySold': 'EGP',
    //         'amountSold': 0,
    //         'amountEGP': 500,
    //         'currencyExchangeRate': 0
    //       },
    //       'factoryUnitValue': null,
    //       'salesTotal': 500,
    //       'discount': {
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'taxableItems': null,
    //       'internalCode': 'IC0',
    //       'itemsDiscount': 0,
    //       'netTotal': 500,
    //       'totalTaxableFees': 0,
    //       'valueDifference': 0,
    //       'total': 500
    //     },
    //     {
    //       'itemPrimaryName': 'SW',
    //       'itemPrimaryDescription': 'Project SRS',
    //       'itemSecondaryName': 'سو',
    //       'itemSecondaryDescription': 'مستند مشروع',
    //       'unitTypePrimaryName': 'each (ST) ( ST )',
    //       'unitTypePrimaryDescription': '',
    //       'unitTypeSecondaryName': '',
    //       'unitTypeSecondaryDescription': '',
    //       'salesTotalForeign': 500,
    //       'netTotalForeign': 500,
    //       'totalForeign': 500,
    //       'totalTaxableFeesForeign': 0,
    //       'itemsDiscountForeign': 0,
    //       'valueDifferenceForeign': 0,
    //       'discountForeign': {
    //         'amountForeign': 0,
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'lineTaxableItems': [
    //         {
    //           'amountForeign': 0,
    //           'taxType': 'T1',
    //           'amount': 0,
    //           'subType': 'V001',
    //           'rate': 0
    //         }
    //       ],
    //       'description': 'Project SRS',
    //       'itemType': 'EGS',
    //       'itemCode': 'EG-628787103-2254',
    //       'unitType': 'EA',
    //       'quantity': 1,
    //       'unitValue': {
    //         'currencySold': 'EGP',
    //         'amountSold': 0,
    //         'amountEGP': 500,
    //         'currencyExchangeRate': 0
    //       },
    //       'factoryUnitValue': null,
    //       'salesTotal': 500,
    //       'discount': {
    //         'rate': 0,
    //         'amount': 0
    //       },
    //       'taxableItems': null,
    //       'internalCode': 'IC0',
    //       'itemsDiscount': 0,
    //       'netTotal': 500,
    //       'totalTaxableFees': 0,
    //       'valueDifference': 0,
    //       'total': 500
    //     }
    //   ],
    //   'references': null,
    //   'salesOrderDescription': 'Sales Order description',
    //   'salesOrderReference': '1231',
    //   'proformaInvoiceNumber': 'SomeValue',
    //   'signatures': [
    //     {
    //       'signatureType': 'I',
    //       'value': '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',
    //       'signedBy': 'اركديف  منطقه حره'
    //     }
    //   ],
    //   'purchaseOrderReference': 'P-233-A6375',
    //   'internalID': '1000009925033',
    //   'taxpayerActivityCode': '8411',
    //   'dateTimeIssued': '2022-06-11T00:00:45Z',
    //   'documentTypeVersion': '1.0',
    //   'documentType': 'I',
    //   'documentTypeNamePrimaryLang': 'Invoice',
    //   'documentTypeNameSecondaryLang': 'فاتورة',
    //   'receiver': {
    //     'address': {
    //       'buildingNumber': 'Bldg. 0',
    //       'room': '123',
    //       'floor': '1',
    //       'street': '580 Clementina Key',
    //       'landmark': '7660 Melody Trail',
    //       'additionalInformation': 'beside Townhall',
    //       'governate': 'New Yourk',
    //       'regionCity': 'New Yourk',
    //       'postalCode': '10014',
    //       'country': 'US',
    //       'branchID': null
    //     },
    //     'type': 2,
    //     'id': '10201020102',
    //     'name': 'Reciver Man'
    //   },
    //   'issuer': {
    //     'address': {
    //       'buildingNumber': 'Bldg. 0',
    //       'room': '123',
    //       'floor': '1',
    //       'street': '580 Clementina Key',
    //       'landmark': '7660 Melody Trail',
    //       'additionalInformation': 'beside Townhall',
    //       'governate': 'Cairo',
    //       'regionCity': 'Nasr City',
    //       'postalCode': '68030',
    //       'country': 'EG',
    //       'branchID': '0'
    //     },
    //     'type': 0,
    //     'id': '628787103',
    //     'name': 'Mo Ali'
    //   },
    //   'extraDiscountAmount': 0,
    //   'maxPercision': 2,
    //   'currenciesSold': 'EGP',
    //   'currencySegments': [
    //     {
    //       'currency': 'EGP',
    //       'currencyExchangeRate': 0,
    //       'totalItemsDiscountAmount': 0,
    //       'totalAmount': 1000,
    //       'taxTotals': [
    //         {
    //           'taxType': 'T1',
    //           'amount': 0
    //         }
    //       ],
    //       'netAmount': 1000,
    //       'totalDiscount': 0,
    //       'totalSales': 1000,
    //       'extraDiscountAmount': 0,
    //       'totalTaxableFees': 0
    //     }
    //   ]
    // }
    // let data = {
    //   "submissionUUID": "5N844V3K6SXJ638T8DRBZ36G10",
    //   "dateTimeRecevied": "2022-06-21T20:30:50.4069114Z",
    //   "validationResults": {
    //     "status": "Valid",
    //     "validationSteps": [
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-06",
    //         "stepId": "15"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-03",
    //         "stepId": "6"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-04",
    //         "stepId": "11"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-05",
    //         "stepId": "14"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-07",
    //         "stepId": "16"
    //       }
    //     ]
    //   },
    //   "transformationStatus": "original",
    //   "statusId": 2,
    //   "status": "Valid",
    //   "documentStatusReason": "Wrong buyer details",
    //   "cancelRequestDate": "2022-06-21T20:31:41.3586276Z",
    //   "rejectRequestDate": null,
    //   "cancelRequestDelayedDate": "2022-06-24T20:31:41.3586276Z",
    //   "rejectRequestDelayedDate": null,
    //   "declineCancelRequestDate": null,
    //   "declineRejectRequestDate": null,
    //   "canbeCancelledUntil": "2022-06-24T20:30:47.2077216Z",
    //   "canbeRejectedUntil": "2022-06-22T08:30:47.2077216Z",
    //   "submissionChannel": 3,
    //   "uuid": "CA7A1HPXM3SDAAS78DRBZ36G10",
    //   "publicUrl": "https://preprod.invoicing.eta.gov.eg/documents/CA7A1HPXM3SDAAS78DRBZ36G10/share/2MG5M8G5RWR0BA368DRBZ36G10CoqCjw1655843447",
    //   "purchaseOrderDescription": "Purchase Order Description",
    //   "totalItemsDiscountAmount": 0,
    //   "delivery": {
    //     "approach": "Approach",
    //     "packaging": "Packaging",
    //     "dateValidity": "2022-06-15T16:51:54Z",
    //     "exportPort": "Export Port",
    //     "countryOfOrigin": null,
    //     "grossWeight": 155,
    //     "netWeight": 162,
    //     "terms": "Delivery Terms"
    //   },
    //   "payment": {
    //     "bankName": "Bank Name",
    //     "bankAddress": "Bank Address",
    //     "bankAccountNo": "Bank Account No",
    //     "bankAccountIBAN": "AB01 2345 6789 ABC123",
    //     "swiftCode": "ABCDEF12",
    //     "terms": "Payment Terms"
    //   },
    //   "totalAmount": 1098.64775,
    //   "taxTotals": [
    //     {
    //       "taxType": "T7",
    //       "amount": 71.6625
    //     },
    //     {
    //       "taxType": "T1",
    //       "amount": 110.36025
    //     }
    //   ],
    //   "netAmount": 916.625,
    //   "totalDiscount": 18.375,
    //   "totalSales": 935,
    //   "invoiceLines": [
    //     {
    //       "itemPrimaryName": "Fruit - Unprepared/Unprocessed (Frozen)",
    //       "itemPrimaryDescription": "",
    //       "itemSecondaryName": "(الفواكه - غير المجهزة / غير المحضرة (مجمدة_237",
    //       "itemSecondaryDescription": "",
    //       "unitTypePrimaryName": "Kilogram ( KG )",
    //       "unitTypePrimaryDescription": "",
    //       "unitTypeSecondaryName": "",
    //       "unitTypeSecondaryDescription": "",
    //       "salesTotalForeign": 735,
    //       "netTotalForeign": 716.625,
    //       "totalForeign": 898.64775,
    //       "totalTaxableFeesForeign": 71.6625,
    //       "itemsDiscountForeign": 0,
    //       "valueDifferenceForeign": 0,
    //       "discountForeign": {
    //         "amountForeign": 18.375,
    //         "rate": 2.5,
    //         "amount": 18.375
    //       },
    //       "lineTaxableItems": [
    //         {
    //           "amountForeign": 71.6625,
    //           "taxType": "T7",
    //           "amount": 71.6625,
    //           "subType": "Ent01",
    //           "rate": 10
    //         },
    //         {
    //           "amountForeign": 110.36025,
    //           "taxType": "T1",
    //           "amount": 110.36025,
    //           "subType": "V001",
    //           "rate": 14
    //         }
    //       ],
    //       "description": "Fruit - Unprepared/Unprocessed (Frozen)",
    //       "itemType": "GS1",
    //       "itemCode": "10000002",
    //       "unitType": "KGM",
    //       "quantity": 3,
    //       "unitValue": {
    //         "currencySold": "EGP",
    //         "amountSold": null,
    //         "amountEGP": 245,
    //         "currencyExchangeRate": null
    //       },
    //       "factoryUnitValue": null,
    //       "salesTotal": 735,
    //       "discount": {
    //         "rate": 2.5,
    //         "amount": 18.375
    //       },
    //       "taxableItems": null,
    //       "internalCode": null,
    //       "itemsDiscount": 0,
    //       "netTotal": 716.625,
    //       "totalTaxableFees": 71.6625,
    //       "valueDifference": 0,
    //       "total": 898.64775
    //     },
    //     {
    //       "itemPrimaryName": null,
    //       "itemPrimaryDescription": null,
    //       "itemSecondaryName": null,
    //       "itemSecondaryDescription": null,
    //       "unitTypePrimaryName": "Kilogram ( KG )",
    //       "unitTypePrimaryDescription": "",
    //       "unitTypeSecondaryName": "",
    //       "unitTypeSecondaryDescription": "",
    //       "salesTotalForeign": 200,
    //       "netTotalForeign": 200,
    //       "totalForeign": 200,
    //       "totalTaxableFeesForeign": 0,
    //       "itemsDiscountForeign": 0,
    //       "valueDifferenceForeign": 0,
    //       "discountForeign": {
    //         "amountForeign": 0,
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "lineTaxableItems": [],
    //       "description": "Activ Faux Leather Sneakers Black N49807520A 1 Piece",
    //       "itemType": "GS1",
    //       "itemCode": "15002000057",
    //       "unitType": "KGM",
    //       "quantity": 1,
    //       "unitValue": {
    //         "currencySold": "EGP",
    //         "amountSold": null,
    //         "amountEGP": 200,
    //         "currencyExchangeRate": null
    //       },
    //       "factoryUnitValue": null,
    //       "salesTotal": 200,
    //       "discount": {
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "taxableItems": null,
    //       "internalCode": null,
    //       "itemsDiscount": 0,
    //       "netTotal": 200,
    //       "totalTaxableFees": 0,
    //       "valueDifference": 0,
    //       "total": 200
    //     }
    //   ],
    //   "references": [],
    //   "salesOrderDescription": "Sales Order Description",
    //   "salesOrderReference": "Sales Order Reference",
    //   "proformaInvoiceNumber": "Proforma Invoice Number",
    //   "signatures": [],
    //   "purchaseOrderReference": "Purchase Order Reference",
    //   "internalID": "343696798825",
    //   "taxpayerActivityCode": "0472",
    //   "dateTimeIssued": "2022-06-21T20:30:46Z",
    //   "documentTypeVersion": "0.9",
    //   "documentType": "i",
    //   "documentTypeNamePrimaryLang": "Invoice",
    //   "documentTypeNameSecondaryLang": "فاتورة",
    //   "receiver": {
    //     "address": {
    //       "buildingNumber": "5",
    //       "room": "802",
    //       "floor": "8",
    //       "street": "Ryada street",
    //       "landmark": "Genena Mall",
    //       "additionalInformation": "Genena Mall",
    //       "governate": "Cairo",
    //       "regionCity": "Nasr City",
    //       "postalCode": "20500",
    //       "country": "EG",
    //       "branchID": null
    //     },
    //     "type": 0,
    //     "id": "111111111",
    //     "name": "test"
    //   },
    //   "issuer": {
    //     "address": {
    //       "buildingNumber": "00000",
    //       "room": null,
    //       "floor": null,
    //       "street": "وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه",
    //       "landmark": null,
    //       "additionalInformation": " ",
    //       "governate": "Ismailia",
    //       "regionCity": "Ismailia",
    //       "postalCode": "00000",
    //       "country": "EG",
    //       "branchID": "0"
    //     },
    //     "type": 0,
    //     "id": "628787103",
    //     "name": "اركديف ش ذ م م م"
    //   },
    //   "extraDiscountAmount": 0,
    //   "maxPercision": 5,
    //   "currenciesSold": "EGP",
    //   "currencySegments": [
    //     {
    //       "currency": "EGP",
    //       "currencyExchangeRate": null,
    //       "totalItemsDiscountAmount": 0,
    //       "totalAmount": 1098.64775,
    //       "taxTotals": [
    //         {
    //           "taxType": "T7",
    //           "amount": 71.6625
    //         },
    //         {
    //           "taxType": "T1",
    //           "amount": 110.36025
    //         }
    //       ],
    //       "netAmount": 916.625,
    //       "totalDiscount": 18.375,
    //       "totalSales": 935,
    //       "extraDiscountAmount": 0,
    //       "totalTaxableFees": 71.6625
    //     }
    //   ]
    // }

    // let data = {
    //   "submissionUUID": "9B67NMWDW7D95XKHGCTEPENG10",
    //   "dateTimeRecevied": "2022-12-29T10:22:16.4643759Z",
    //   "validationResults": {
    //     "status": "Valid",
    //     "validationSteps": [
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-04",
    //         "stepId": "11"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-03",
    //         "stepId": "6"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-05",
    //         "stepId": "14"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-06",
    //         "stepId": "15"
    //       },
    //       {
    //         "status": "Valid",
    //         "error": null,
    //         "stepName": "Step-07",
    //         "stepId": "16"
    //       }
    //     ]
    //   },
    //   "transformationStatus": "original",
    //   "statusId": 2,
    //   "status": "Valid",
    //   "documentStatusReason": "",
    //   "cancelRequestDate": null,
    //   "rejectRequestDate": null,
    //   "cancelRequestDelayedDate": null,
    //   "rejectRequestDelayedDate": null,
    //   "declineCancelRequestDate": null,
    //   "declineRejectRequestDate": null,
    //   "canbeCancelledUntil": "2022-12-30T10:22:16.4643759Z",
    //   "canbeRejectedUntil": "2022-12-30T10:22:16.4643759Z",
    //   "submissionChannel": 3,
    //   "freezeStatus": {
    //     "frozen": false,
    //     "type": null,
    //     "actionDate": null,
    //     "auCode": null,
    //     "auName": null
    //   },
    //   "uuid": "65WPNAJ7SZSR6XQSGCTEPENG10",
    //   "publicUrl": "https://preprod.invoicing.eta.gov.eg/documents/65WPNAJ7SZSR6XQSGCTEPENG10/share/5VRYF9D354FXZ1PFGCTEPENG10dRQjg51672309336",
    //   "purchaseOrderDescription": null,
    //   "totalItemsDiscountAmount": 0,
    //   "delivery": {
    //     "approach": null,
    //     "packaging": null,
    //     "dateValidity": null,
    //     "exportPort": null,
    //     "countryOfOrigin": null,
    //     "grossWeight": 0,
    //     "netWeight": null,
    //     "terms": null
    //   },
    //   "payment": {
    //     "bankName": null,
    //     "bankAddress": null,
    //     "bankAccountNo": null,
    //     "bankAccountIBAN": null,
    //     "swiftCode": null,
    //     "terms": null
    //   },
    //   "totalAmount": 5296,
    //   "taxTotals": [
    //     {
    //       "taxType": "T5",
    //       "amount": 160
    //     },
    //     {
    //       "taxType": "T4",
    //       "amount": 160
    //     },
    //     {
    //       "taxType": "T1",
    //       "amount": 176
    //     },
    //     {
    //       "taxType": "T8",
    //       "amount": 320
    //     }
    //   ],
    //   "netAmount": 4800,
    //   "totalDiscount": 0,
    //   "totalSales": 4800,
    //   "invoiceLines": [
    //     {
    //       "itemPrimaryName": "Base It Light-cured base/liner containing calcium hydroxyapatite in urethane methacrylate oligomer.",
    //       "itemPrimaryDescription": "",
    //       "itemSecondaryName": "غير موجود",
    //       "itemSecondaryDescription": "",
    //       "unitTypePrimaryName": "Kilogram ( KG )",
    //       "unitTypePrimaryDescription": "",
    //       "unitTypeSecondaryName": "",
    //       "unitTypeSecondaryDescription": "",
    //       "salesTotalForeign": 100,
    //       "netTotalForeign": 100,
    //       "totalForeign": 111,
    //       "totalTaxableFeesForeign": 10,
    //       "itemsDiscountForeign": 0,
    //       "valueDifferenceForeign": 0,
    //       "discountForeign": {
    //         "amountForeign": 0,
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "lineTaxableItems": [
    //         {
    //           "amountForeign": 10,
    //           "taxType": "T5",
    //           "amount": 160,
    //           "subType": "ST01",
    //           "rate": 10
    //         },
    //         {
    //           "amountForeign": 10,
    //           "taxType": "T4",
    //           "amount": 160,
    //           "subType": "W001",
    //           "rate": 10
    //         },
    //         {
    //           "amountForeign": 11,
    //           "taxType": "T1",
    //           "amount": 176,
    //           "subType": "V009",
    //           "rate": 10
    //         }
    //       ],
    //       "description": "Base It Light-cured base/liner containing calcium hydroxyapatite in urethane methacrylate oligomer.",
    //       "itemType": "GS1",
    //       "itemCode": "00000202209089",
    //       "unitType": "KGM",
    //       "quantity": 2,
    //       "unitValue": {
    //         "currencySold": "AED",
    //         "amountSold": 50,
    //         "amountEGP": 800,
    //         "currencyExchangeRate": 16
    //       },
    //       "factoryUnitValue": null,
    //       "salesTotal": 1600,
    //       "discount": {
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "taxableItems": null,
    //       "internalCode": "123",
    //       "itemsDiscount": 0,
    //       "netTotal": 1600,
    //       "totalTaxableFees": 160,
    //       "valueDifference": 0,
    //       "total": 1776
    //     },
    //     {
    //       "itemPrimaryName": "SW",
    //       "itemPrimaryDescription": "Project SRS",
    //       "itemSecondaryName": "سو",
    //       "itemSecondaryDescription": "مستند مشروع",
    //       "unitTypePrimaryName": "Kilogram ( KG )",
    //       "unitTypePrimaryDescription": "",
    //       "unitTypeSecondaryName": "",
    //       "unitTypeSecondaryDescription": "",
    //       "salesTotalForeign": 200,
    //       "netTotalForeign": 200,
    //       "totalForeign": 220,
    //       "totalTaxableFeesForeign": 20,
    //       "itemsDiscountForeign": 0,
    //       "valueDifferenceForeign": 0,
    //       "discountForeign": {
    //         "amountForeign": 0,
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "lineTaxableItems": [
    //         {
    //           "amountForeign": 20,
    //           "taxType": "T8",
    //           "amount": 320,
    //           "subType": "RD01",
    //           "rate": 10
    //         }
    //       ],
    //       "description": "Project SRS",
    //       "itemType": "EGS",
    //       "itemCode": "EG-628787103-2254",
    //       "unitType": "KGM",
    //       "quantity": 4,
    //       "unitValue": {
    //         "currencySold": "AED",
    //         "amountSold": 50,
    //         "amountEGP": 800,
    //         "currencyExchangeRate": 16
    //       },
    //       "factoryUnitValue": null,
    //       "salesTotal": 3200,
    //       "discount": {
    //         "rate": 0,
    //         "amount": 0
    //       },
    //       "taxableItems": null,
    //       "internalCode": "1232131",
    //       "itemsDiscount": 0,
    //       "netTotal": 3200,
    //       "totalTaxableFees": 320,
    //       "valueDifference": 0,
    //       "total": 3520
    //     }
    //   ],
    //   "references": [],
    //   "salesOrderDescription": null,
    //   "salesOrderReference": null,
    //   "proformaInvoiceNumber": null,
    //   "signatures": [],
    //   "purchaseOrderReference": null,
    //   "internalID": "20952638313",
    //   "taxpayerActivityCode": "0472",
    //   "dateTimeIssued": "2022-12-29T10:22:14Z",
    //   "documentTypeVersion": "0.9",
    //   "documentType": "i",
    //   "documentTypeNamePrimaryLang": "Invoice",
    //   "documentTypeNameSecondaryLang": "فاتورة",
    //   "receiver": {
    //     "address": {
    //       "buildingNumber": "18",
    //       "room": "",
    //       "floor": "",
    //       "street": "EF_Test",
    //       "landmark": "",
    //       "additionalInformation": "",
    //       "governate": "Giza",
    //       "regionCity": "Giza",
    //       "postalCode": "",
    //       "country": "EG",
    //       "branchID": null
    //     },
    //     "type": 0,
    //     "id": "111111111",
    //     "name": "test"
    //   },
    //   "issuer": {
    //     "address": {
    //       "buildingNumber": "00000",
    //       "room": null,
    //       "floor": null,
    //       "street": "وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه",
    //       "landmark": null,
    //       "additionalInformation": " ",
    //       "governate": "Ismailia",
    //       "regionCity": "Ismailia",
    //       "postalCode": "00000",
    //       "country": "EG",
    //       "branchID": "0"
    //     },
    //     "type": 0,
    //     "id": "628787103",
    //     "name": "اركديف ش ذ م م م"
    //   },
    //   "extraDiscountAmount": 0,
    //   "maxPercision": 2,
    //   "currenciesSold": "Foreign",
    //   "currencySegments": [
    //     {
    //       "currency": "AED",
    //       "currencyExchangeRate": 16,
    //       "totalItemsDiscountAmount": 0,
    //       "totalAmount": 331,
    //       "taxTotals": [
    //         {
    //           "taxType": "T5",
    //           "amount": 10
    //         },
    //         {
    //           "taxType": "T4",
    //           "amount": 10
    //         },
    //         {
    //           "taxType": "T1",
    //           "amount": 11
    //         },
    //         {
    //           "taxType": "T8",
    //           "amount": 20
    //         }
    //       ],
    //       "netAmount": 300,
    //       "totalDiscount": 0,
    //       "totalSales": 300,
    //       "extraDiscountAmount": 0,
    //       "totalTaxableFees": 30
    //     }
    //   ]
    // }

    // setInvoiceData(arrangeSingleInvoice(data, locale))
    // setIsUserSubmitter(data?.issuer?.id?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString())
    if (!!keycloak?.authenticated && !!id) {
      setInvoiceDataLoading(true)
      ListingServices.getInvoiceData(id, intl.formatMessage({ id: 'single.invoice.Error' })).then((result) => {
        if (!!result?.response && result?.response?.status === 403) {
          setIsUnauthorized(true)
        } else if (!!result && !!result.data) {
          let itemsDone = false
          setIsUserSubmitter(result.data?.issuer?.id?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString())

          ListingServices.getInvoiceDownloadData('', id, null, intl.formatMessage({ id: 'single.invoice.items.Error' }), '')
            .then((rowResult) => {
              if (!!rowResult && !!rowResult.data && !!rowResult.data['document']) {
                let doc = JSON.parse(rowResult.data['document'])
                setInvoiceData(arrangeSingleInvoice({
                  ...result.data,
                  invoiceLines: doc.invoiceLines
                }, locale))
                itemsDone = true
              }
            }).then(() => {
            if (!itemsDone) {
              setInvoiceData(arrangeSingleInvoice(result.data, locale))
            }
          })
        }
      }).then(() => {
        setInvoiceDataLoading(false)
      })
    }
  }

  const getMsInvoiceData = () => {
    if (!!keycloak?.authenticated && !!id) {
      setInvoiceDataLoading(true)
      ListingServices.getMsInvoiceData(id, intl.formatMessage({ id: 'single.invoice.Error' })).then((result) => {
        if (!!result?.response && result?.response?.status === 403) {
          setIsUnauthorized(true)
        } else if (!!result && !!result.data) {
          let related = false
          setIsUserSubmitter(result.data?.issuer?.id?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString())
          ListingServices.getInvoicesListingData(InvoicesListingParamsPayload(1, 1, { msUUID: id }),
            intl.formatMessage({ id: `invoice.relatedSP.error` })).then((list) => {
            if (!!list && !!list?.data?.result?.length) {
              setInvoiceData(arrangeSingleInvoice({
                ...result.data,
                SPuuid: list?.data?.result[0]?.uuid || ''
              }, locale))
              related = true
            }
          }).then(() => {
            if (!related) {
              setInvoiceData(arrangeSingleInvoice(result.data, locale))
            }
          })
        }
      }).then(() => {
        setInvoiceDataLoading(false)
      })
    }
  }

  return (
    <InvoiceViewContext.Provider value={{
      id,
      invoiceData,
      invoiceDataLoading,
      isUserSubmitter,
      isUnauthorized,
      getInvoiceData,
      getMsInvoiceData
    }}>
      {children}
    </InvoiceViewContext.Provider>
  )
}
const InvoiceViewConsumer = InvoiceViewContext.Consumer

export { InvoiceViewProvider, InvoiceViewConsumer }
